import { Box } from '@mui/material';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentUserIsViewOnly } from 'spw-redux/modules/projects/selectors';
import styled from 'styled-components';

const ImageWrapper = styled.div`
  && {
    width: 55px;
    display: flex;
    justify-content: center;
    cursor: pointer;

    margin: 0 4px;
    border-radius: 4px;

    &:hover {
      background-color: #eee;
    }

    &.selected {
      background-color: #eee;
    }

    &.disabled {
      cursor: default;

      &:hover {
        background-color: transparent;
      }
    }
  }
`;

const BigImageWrapper = styled(Box)`
  && {
    display: flex;
    justify-content: center;
    cursor: pointer;
    margin: 8px 0;

    border: 1px solid #e0e0e0;
    border-radius: 4px;
  }

  &&:hover {
    background-color: #eee;
  }

  &&.active {
    background-color: #eeeeee;
    border-color: #a8a8a8;
  }

  &&.disabled {
    cursor: default;
    background-color: #f7f7f7;
    border-color: #f7f7f7;
  }
`;

type ISpaceIconProps = {
  // This is the top-level category: individual workspaces, meeting, etc
  topLevelProjectSpaceTypeCategoryId: number;
  projectSpaceTypeCategoryId: number;
  projectSpaceTypeId: number;
  spaceTypeId?: number;
  iconName: string;
  defaultIconName: string;
  name: string;
  disabled?: boolean;
  onClick?: (e: Element) => void;
};
export const SpaceIcon = ({
  topLevelProjectSpaceTypeCategoryId,
  projectSpaceTypeCategoryId,
  projectSpaceTypeId,
  spaceTypeId,
  iconName,
  defaultIconName,
  name,
  disabled,
  onClick,
}: ISpaceIconProps) => {
  const currentUserIsViewOnly = useSelector(selectCurrentUserIsViewOnly);
  return (
    <ImageWrapper
      className={disabled ? 'disabled' : undefined}
      onClick={
        currentUserIsViewOnly
          ? undefined
          : (e) => {
              if (onClick) {
                onClick(e.currentTarget);
              }
            }
      }
      data-space-type-id={spaceTypeId}
      data-project-space-type-category-id={projectSpaceTypeCategoryId}
      data-top-level-project-space-type-category-id={
        topLevelProjectSpaceTypeCategoryId
      }
      data-project-space-type-id={projectSpaceTypeId}
      data-icon-name={iconName}
      data-default-icon-name={defaultIconName}
    >
      <img
        width={42}
        height={28}
        src={`/images/space-icons/${iconName}.svg`}
        style={{ margin: '4px 0px' }}
        alt={`${name}-icon`}
        data-testid={iconName}
      />
    </ImageWrapper>
  );
};

type IOutlinedSpaceIconProps = {
  name: string;
  onClick?: (e: Element) => void;
  active?: boolean;
  disabled: boolean;
  width?: number;
  height?: number;
};
export const OutlinedSpaceIcon = ({
  active,
  name,
  onClick,
  disabled,
  width = 67,
  height = 40,
}: IOutlinedSpaceIconProps) => (
  <BigImageWrapper
    className={[active ? 'active' : null, disabled ? 'disabled' : null].join(
      ' '
    )}
    width={width}
    onClick={(e) => {
      if (onClick && !disabled) onClick(e.currentTarget);
    }}
    onMouseDown={(e) => e.stopPropagation()}
  >
    <img
      height={height}
      src={`/images/space-icons/${name}.svg`}
      style={{
        margin: '7px 0px',
        filter: `invert(${disabled ? '75' : '0'}%)`,
      }}
      alt={`${name}-icon`}
    />
  </BigImageWrapper>
);
